import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { productSlice } from './productStore';
import { businessListSlice } from './businessListStore';
import { businessSlice } from './businessStore';
import { salesSlice } from './salesStore';

export const store = configureStore({
  reducer: {
    products: productSlice.reducer,
    businessList: businessListSlice.reducer,
    business: businessSlice.reducer,
    sales: salesSlice.reducer
  }
});

export type State = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
export const useAppSelector: TypedUseSelectorHook<State> = useSelector;
